import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53b695ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "details_dj" }
const _hoisted_3 = { class: "details_dj_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_x" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投料信息", -1))
const _hoisted_6 = { class: "details_dj_list" }
const _hoisted_7 = { class: "details_dj_list_item" }
const _hoisted_8 = { class: "details_dj_list_item_top" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "details_dj_list_item_bottom" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_zw" }, null, -1))
const _hoisted_14 = { class: "details_footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_16 = [
  _hoisted_15
]

import { ref, onMounted, nextTick, watch } from 'vue'
    import { Toast } from 'vant'
    import { REGULAR } from '@/utils/utils'
    import { useRouter, useRoute } from "vue-router"
    import { getBarcodeContent, queryById, toolingQueryById, createMaterial } from '@/apis/WorkOrderAPI'
    import vScanCode from '@/components/common/ScanCode.vue'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const info: any = ref({})

    const router = useRouter()
    let total = ref<number>(0)
    const route = useRoute()

    // 投料信息
    let listData: any = ref([])

    // 失去焦点验证整数小数
    const changeNumber = (num: any, index: number, umodelData: number): void => {
        if (umodelData === 0 && num !== '') {  // 整数
            if(!REGULAR.positiveInteger.test(num)){
                Toast({ message: '只能输入正整数' })
                listData.value[index].num = ''
            }
        } else if (umodelData === 1 && num !== '') {  // 小数（只支持四位小数）
            if(!REGULAR.number.test(num)){
                Toast({ message: '只能输入正整数或小数（最多四位）' })
                listData.value[index].num = ''
            }
        }
    }

    // 删除一条投料信息
    const dele = (index: any): void => {
        if (listData.value.length === 1) {
            Toast({
                message: '至少添加一条投料信息',
                duration: 2000
            })
            return
        }
        listData.value.splice(index, 1)
    }

    // 控制扫码显示隐藏
    const openCode = ref<boolean>(false)

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 继续扫码
    const continueScanning = () => {
        openCode.value = true
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        getBarcodeContent({
            barcode: data[0]
        }).then(res => {
            if (res.code === 200) {
                if (res.data.barcodeType === 4) {
                    toolingQueryByIds(res.data.id)
                } else {
                    Toast({
                        message: '请扫描正确的篮筐码',
                        duration: 2000
                    })
                }
            }
        })
        nextTick(() => {
            openCode.value = false
        })
    }

    // 查询工单详情
    const queryByIds = () => {
        queryById(route.query.id).then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
    }

    // 根据工装器具id获取详情
    const toolingQueryByIds = (id: any): void => {
        toolingQueryById({ id })
            .then(res => {
                if (res.code === 200) {
                    if (res.data[0].status === 0) {
                        Toast({ message: '该工装已报废' })
                    } else if (res.data[0].status === 1) {
                        Toast({ message: '该工装为空' })
                    }
                    let isOpen = true
                    listData.value.forEach((item: any) => {
                        if (item.id === res.data[0].id) {
                            isOpen = false
                        }
                    })
                    if (isOpen) {
                        listData.value.push({ id: res.data[0].id, code: res.data[0].code + ' - ' + res.data[0].mmodelName, total: res.data[0].num, num: res.data[0].num, dw: res.data[0].umodelName, umodelData: res.data[0].umodelData })
                    } else {
                        Toast({ message: '工装已存在', duration: 2000 })
                    }
                }
            })
    }

    // 提交投料
    const submit = () => {
        let isOpen = true
        listData.value.forEach((item: any) => {
            if (item.num === '') {
                isOpen = false
                Toast({ message: `[${item.code}]投料数量不能为空`, duration: 2000 })
            }
            if (item.num > item.total) {
                isOpen = false
                Toast({ message: `[${item.code}]投料数量不能大于生产数量`, duration: 2000 })
                return
            }
        })

        if (isOpen) {
            let recordList: any = []
            listData.value.forEach((item: any) => {
                recordList.push({ applianceId: item.id, num: item.num })
            })
            createMaterial({
                id: route.query.id,
                recordList: recordList
            }).then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '投料成功', duration: 2000, forbidClick: true })
                    setTimeout(() => {
                        router.go(-1)
                    }, 2000)
                }
            })
        }
    }

    watch(() => listData.value, (news) => {
        total.value = 0
        news.forEach((element: any) => {
            total.value = total.value + Number(element.num)
        })
    }, { deep: true })

    onMounted(() => {
        queryByIds()
        toolingQueryByIds(route.query.gzId)
    })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VWorkOrderInfo, { info: info.value }, null, 8, ["info"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_unref(total) == 0 ? '' : _unref(total)), 1),
          (_unref(listData).length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(listData)[_unref(listData).length - 1].dw ? _unref(listData)[_unref(listData).length - 1].dw : ''), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              style: {"height":"100%"},
              square: "",
              type: "danger",
              text: "删除",
              onClick: ($event: any) => (dele(index))
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(item.code), 1),
                  (info.value.umodel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.total) + _toDisplayString(item.dw), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (info.value.umodel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "投料数量(" + _toDisplayString(item.dw) + ")：", 1))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                    onBlur: ($event: any) => (changeNumber(item.num, index, item.umodelData)),
                    type: "text"
                  }, null, 40, _hoisted_12), [
                    [_vModelText, item.num]
                  ])
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        class: "details_footer_buttona",
        onClick: continueScanning
      }, "继续扫码"),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "details_footer_buttonb",
        onClick: submit
      }, _hoisted_16)), [
        [_directive_preventReClick]
      ])
    ]),
    _createVNode(vScanCode, {
      openCode: openCode.value,
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"])
  ]))
}
}

})